const fr = {
	// General
	"app.title": "Numerys",
	"app.description": "Suivez facilement vos dépenses et vos revenus",
	"global.appLoading": "Chargement...",

	// Login page
	"login.email": "E-mail",
	"login.password": "Mot de passe",
	"login.emailPlaceholder": "Entrez votre e-mail",
	"login.passwordPlaceholder": "Entrez votre mot de passe",
	"login.submit": "Se connecter",
	"login.loading": "Connexion...",
	"login.forgotPassword": "Mot de passe oublié",
	"login.noAccount": "Vous n'avez pas encore de compte ?",
	"login.signupLink": "S'inscrire",
	"login.error.invalidCredential":
		"Identifiants invalides. Veuillez vérifier votre e-mail et mot de passe.",
	"login.error.generic": "Erreur lors de la connexion.",
	"login.error.emailRequired": "Veuillez renseigner votre e-mail.",
	"login.error.resetPassword":
		"Erreur d'envoi de l'e-mail de réinitialisation.",

	// Register page
	"register.submit": "Créer un compte",
	"register.haveAccount": "Vous avez déjà un compte ?",
	"register.loginLink": "Se connecter",
	"register.accept": "J'ai lu et j'accepte les",
	"register.terms": "Conditions Générales d'Utilisation",
	"register.loading": "Inscription en cours...",
	"register.error.emailInUse": "Cette adresse e-mail est déjà utilisée.",
	"register.error.invalidEmail": "Adresse e-mail invalide.",
	"register.error.weakPassword":
		"Mot de passe trop faible (minimum 6 caractères).",
	"register.error.generic": "Erreur lors de l'inscription.",
	"register.error.emailNotWhitelisted":
		"Votre adresse e-mail n'est pas autorisée. Veuillez contacter l'administrateur.",
	"register.error.mustAcceptTerms":
		"Vous devez accepter les Conditions Générales d'Utilisation pour vous inscrire.",

	// Navigation
	"nav.login": "Connexion",
	"nav.register": "S'inscrire",
	"nav.home": "Synthèse",
	"nav.history": "Historique",
	"nav.analysis": "Analyse",
	"nav.add": "Ajouter",
	"nav.settings": "Réglages",

	// Home page
	"home.title": "Synthèse",
	"home.loading": "Chargement des statistiques de synthèse...",
	"home.empty.title": "Aucune donnée disponible",
	"home.empty.description":
		"Commencez par ajouter vos premières transactions pour voir vos statistiques.",
	"home.totalAllTime": "Tout",
	"home.total": "Total ",
	"home.totalSpent": "Total dépensé",
	"home.totalWithoutHousing": "Total hors logement",
	"home.totalIncome": "Revenus totaux",
	"home.balance": "Solde",
	"home.noTransactions": "Aucune transaction disponible.",
	"home.ofExpenses": "des dépenses",
	"home.ofIncome": "des revenus",

	// History page
	"history.title": "Historique des transactions",
	"history.loading": "Chargement des transactions...",
	"history.empty.title": "Aucune transaction enregistrée pour le moment",
	"history.empty.description":
		"Vous n'avez pas encore ajouté de transactions. Créez-en une depuis le formulaire d'ajout.",
	"history.loadData.title": "Prêt à charger vos transactions",
	"history.loadData.description":
		"Cliquez ci-dessous pour charger l'historique de vos transactions",
	"history.loadData.button": "Charger les données",
	"history.loadMore": "Charger plus",
	"history.groupModeToggle": "Basculer le mode de regroupement",
	"history.groupByDay": "Grouper par date",
	"history.groupByCategory": "Grouper par catégorie",
	"history.view": "Détail",
	"history.confirmDelete": "Supprimer la transaction",
	"history.search.placeholder": "Rechercher par titre, date, montant...",
	"history.search.noResults.title": "Aucun résultat",
	"history.search.noResults.description":
		"Aucune transaction ne correspond à {{searchQuery}}",

	// Analysis page
	"analysis.title": "Analyse",
	"analysis.loading": "Chargement des statistiques...",
	"analysis.empty.title": "Aucune donnée disponible",
	"analysis.empty.description":
		"Aucune donnée de transaction n'est disponible. Ajoutez des transactions pour voir vos analyses.",
	"analysis.noChartsData.title": "Aucun graphique à afficher",
	"analysis.noChartsData.description":
		"Les filtres sélectionnés ne correspondent à aucune donnée pour cette année.",
	"analysis.average": "Moy",
	"analysis.monthlyExpensesByCategory": "Dépenses mensuelles par catégorie",
	"analysis.selectYear": "Année",
	"analysis.selectCategories": "Catégories",
	"analysis.expenseBreakdown": "Répartition des dépenses",
	"analysis.monthlyOverview": "Vue d'ensemble mensuelle",
	"analysis.income": "Revenus :",
	"analysis.expenses": "Dépenses :",
	"analysis.expenseTotal": "Dépenses",
	"analysis.balance": "Solde",
	"analysis.monthlyIncome": "Revenus mensuels",
	"analysis.incomeBySubcategory": "Répartition des revenus",
	"analysis.yearlyEvolutionByCategory":
		"Évolution annuelle des dépenses par catégorie",
	"analysis.legend.actual": "Données actuelles",
	"analysis.legend.projected": "Projection annuelle",
	"analysis.tooltip.basedOnMonths": "Projection basée sur {{count}} mois",
	"analysis.monthlyBalance": "Évolution mensuelle du solde",
	"analysis.yearlyBalance": "Évolution annuelle du solde",

	// Add transaction page
	"add.title": "Ajouter une transaction",

	// Settings page
	"settings.title": "Réglages",
	"settings.loading": "Chargement des réglages...",
	"settings.theme": "Thème",
	"settings.useSystemTheme": "Appliquer le thème de l'appareil",
	"settings.light": "Activer le mode sombre",
	"settings.dark": "Désactiver le mode sombre",
	"settings.design": "Apparence",
	"settings.bottomNavStyle": "Choisir le style de la barre de navigation",
	"settings.fixed": "Fixée",
	"settings.floating": "Flottante",
	"settings.full": "Pleine",
	"settings.designStyle": "Choisir le style de l'app",
	"settings.ios18Style": "iOS 18",
	"settings.ios26Style": "iOS 26",
	"settings.language": "Langue",
	"settings.selectLanguage": "Choisir la langue",
	"settings.account": "Mon compte",
	"settings.email": "E-mail",
	"settings.emailNotConfirmed": "non vérifié",
	"settings.emailConfirmed": "confirmé",
	"settings.resetPassword": "Réinitialiser mon mot de passe",
	"settings.changeEmail": "Modifier mon adresse e-mail",
	"settings.enterNewEmail": "Entrez votre nouvelle adresse e-mail",
	"settings.export": "Exporter mes données",
	"settings.exporting": "Export en cours...",
	"settings.exportLoading":
		"Export de l'ensemble de vos données personnelles en cours...",
	"settings.logout": "Me déconnecter",
	"settings.deleteAccount": "Supprimer mon compte",
	"settings.deleteAccountButton": "Supprimer le compte",
	"settings.deletingAccount": "Suppression du compte en cours...",
	"settings.accountDeleted":
		"Votre compte et toutes vos données ont bien été supprimés.",
	"settings.enterPasswordToConfirm":
		"Veuillez entrer votre mot de passe pour confirmer.",
	"settings.legalInfo": "Informations légales",
	"settings.accessAdmin": "Accéder à l'espace admin",

	// Admin page
	"admin.title": "Admin",
	"admin.loading": "Chargement de la page admin...",
	"admin.manageWhitelist": "Gérer la liste blanche",
	"admin.addToWhitelist": "Ajouter",
	"admin.removeFromWhitelist": "Supprimer de la liste blanche",
	"admin.delete": "Supprimer",
	"admin.confirmDeleteWhitelist":
		"Êtes-vous sûr de vouloir supprimer l'adresse « {{email}} » de la liste blanche ?",
	"admin.emailRemoved": "L'adresse e-mail a été retirée de la liste blanche.",
	"admin.manageUsers": "Gérer les utilisateurs",
	"admin.email": "E-mail",
	"admin.emailVerified": "E-mail vérifié",
	"admin.changeRole": "Rôle",
	"admin.emailRequired": "Adresse e-mail requise.",
	"admin.emailAdded": "Adresse e-mail ajoutée à la liste blanche.",
	"admin.emailAddError": "Erreur lors de l'ajout à la liste blanche.",
	"admin.emailRemoveError":
		"Erreur lors de la suppression de la liste blanche.",
	"admin.roleUpdateError":
		"Erreur lors de la mise à jour du rôle de l'utilisateur.",
	"admin.updatingRole": "Mise à jour du rôle...",
	"admin.roleUpdated": "Rôle de l'utilisateur mis à jour avec succès",
	"admin.seeMore": "Voir plus",
	"admin.seeLess": "Voir moins",
	"admin.recurringTransactions": "Transactions récurrentes",
	"admin.recurringDescription":
		"Mettre à jour les transactions récurrentes des prochaines 48 heures",
	"admin.processRecurring": "Mettre à jour",
	"admin.processingRecurring": "Mise à jour des transactions récurrentes...",
	"admin.recurringProcessed":
		"{{processed}} transactions traitées, {{skipped}} ignorées (en pause), {{failed}} échecs.",
	"admin.recurringProcessError":
		"Erreur lors du traitement des transactions récurrentes : ",
	"admin.emailPlaceholder": "utilisateur@exemple.com",
	"admin.yes": "✅",
	"admin.no": "❌",
	"admin.roleUser": "User",
	"admin.roleAdmin": "Admin",

	// Reauth Form
	"reauth.title": "Ré-authentification requise",
	"reauth.description":
		"Pour des raisons de sécurité, veuillez confirmer votre mot de passe pour continuer.",
	"reauth.placeholder": "Votre mot de passe",

	// Add transaction form
	"form.expense": "Dépense",
	"form.income": "Revenu",
	"form.title": "Titre",
	"form.titlePlaceholder": "Ex. Boissons",
	"form.amount": "Montant",
	"form.amountPlaceholder": "12,50 €",
	"form.date": "Date",
	"form.nextOccurrence": "Prochaine occurrence",
	"form.invalidDate": "Date invalide",
	"form.category": "Catégorie",
	"form.subCategory": "Sous-catégorie",
	"form.selectSubCat": "-- Sélectionner --",
	"form.noSubCatConfig":
		"Aucune sous-catégorie configurée pour cette catégorie.",
	"form.noSubCategory": "Aucune sous-catégorie",
	"form.actions": "Actions",
	"form.delete": "Supprimer",
	"form.add": "Ajouter une transaction",
	"form.adding": "Ajout en cours...",
	// Recurring transaction form
	"form.recurring.enable": "Transaction récurrente",
	"form.recurring.frequency": "Fréquence",
	"form.recurring.interval": "Intervalle",
	"form.recurring.increment": "Augmenter l'intervalle",
	"form.recurring.decrement": "Diminuer l'intervalle",
	"form.recurringFrequency.days": "Quotidienne",
	"form.recurringFrequency.weeks": "Hebdomadaire",
	"form.recurringFrequency.months": "Mensuelle",
	"form.recurringFrequency.years": "Anuelle",
	"form.recurring.days": "jours",
	"form.recurring.days_plural": "{{count}} jours",
	"form.recurring.weeks": "semaines",
	"form.recurring.weeks_plural": "{{count}} semaines",
	"form.recurring.months": "mois",
	"form.recurring.months_plural": "{{count}} mois",
	"form.recurring.years": "ans",
	"form.recurring.years_plural": "{{count}} ans",
	"form.recurringDeterminant.days.one": "tous les",
	"form.recurringDeterminant.days.other": "tous les",
	"form.recurringDeterminant.weeks.one": "toutes les",
	"form.recurringDeterminant.weeks.other": "toutes les",
	"form.recurringDeterminant.months.one": "tous les",
	"form.recurringDeterminant.months.other": "tous les",
	"form.recurringDeterminant.years.one": "tous les",
	"form.recurringDeterminant.years.other": "tous les",
	"form.recurring.summary":
		"Cette transaction sera répétée {{determinant}} {{intervalAndUnit}} à partir du {{date}}",
	"form.recurring.manage": "Gérer les récurrences",

	// Recurring transactions page
	"recurring.title": "Transactions récurrentes",
	"recurring.loading": "Chargement des transactions récurrentes...",
	"recurring.active": "Active",
	"recurring.paused": "En pause",
	"recurring.next": "À venir :",
	"recurring.pause": "Mettre en pause",
	"recurring.resume": "Reprendre",
	"recurring.pausing": "Mise en pause de la récurrence...",
	"recurring.resuming": "Reprise de la récurrence...",
	"recurring.delete": "Supprimer la récurrence",
	"recurring.empty.title": "Aucune transaction récurrente",
	"recurring.empty.description":
		"Vous n'avez pas encore configuré de transactions récurrentes. Créez-en une depuis le formulaire d'ajout.",
	"recurring.edit": "Modifier la récurrence",
	"recurring.upcoming.title": "À venir",
	"recurring.upcoming.seeAll": "Voir tout",
	"recurring.upcoming.today": "Aujourd'hui",
	"recurring.upcoming.tomorrow": "Demain",

	// 404 - Not Found page
	"404.title": "Page not found",
	"404.message": "Oups ! Page introuvable.",
	"404.backHome": "Retour à l'accueil",

	// Action buttons
	"action.edit": "Modifier",
	"action.delete": "Supprimer",
	"action.deleting": "Suppression en cours...",
	"action.back": "Retour",
	"action.save": "Enregistrer",
	"action.saving": "Enregistrement...",
	"action.confirm": "Confirmer",
	"action.confirming": "Confirmation...",
	"action.cancel": "Annuler",
	"action.resendVerification": "Renvoyer l'e-mail de vérification",

	// Alert and errors inside the app
	"alert.userNotLoggedIn": "Utilisateur non connecté.",
	"alert.missingMandatoryFields":
		"Veuillez remplir tous les champs obligatoires !",
	// Transactions: add/fetch/edit/delete
	"alert.addingTransaction": "Ajout en cours...",
	"alert.transactionAdded": "Transaction ajoutée avec succès !",
	"alert.transactionError": "Erreur lors de l'ajout de la transaction.",
	"error.fetchTransactions": "Erreur lors de la récupération des transactions.",
	"alert.futureDateRequired":
		"La date de la prochaine ocurrence doit être dans le futur.",
	"alert.updateSuccess": "Transaction mise à jour avec succès.",
	"alert.recurringUpdateSuccess": "Récurrence mise à jour avec succès.",
	"alert.updateError": "Erreur lors de la mise à jour.",
	"alert.saveError": "Erreur lors de l'enregistrement. Veuillez réessayer.",
	"alert.confirmDeleteEntry":
		"Êtes-vous sûr de vouloir supprimer cette transaction ?",
	"alert.deleteSuccess": "Transaction supprimée avec succès.",
	"error.deleteTransaction": "Erreur lors de la suppression de la transaction.",
	"error.deleteRecurring": "Erreur lors de la suppression de la récurrence.",
	"alert.recurringPaused": "Récurrence mise en pause.",
	"alert.recurringResumed": "Récurrence reprise.",
	"alert.confirmDeleteRecurring":
		"Êtes-vous sûr de vouloir supprimer cette récurrence ? Cela n'affectera pas les transactions déjà créées.",
	"alert.recurringDeleted": "Récurrence supprimée avec succès.",
	// Generic alerts and errors
	"alert.genericError": "Une erreur est survenue. Merci de réessayer.",
	"error.permissions":
		"Vous n'avez pas les permissions pour accéder à ces données.",
	"error.title": "Une erreur est survenue",
	"error.message": "Erreur :",
	"error.network":
		"Aucune connexion internet. Vérifiez votre réseau et réessayez.",
	"error.userNotConnected": "Utilisateur non connecté",
	"error.retry": "Réessayer",
	// Settings alerts and errors
	"alert.emailNotVerified":
		"Veuillez vérifier votre adresse e-mail pour accéder au reste de l'application.",
	"alert.verificationEmailSent": "Un e-mail de vérification a été envoyé.",
	"alert.verificationEmailError":
		"Échec de l'envoi de l'e-mail de vérification.",
	"alert.emailUpdateError":
		"Erreur lors de la mise à jour de l'adresse e-mail.",
	"alert.invalidEmail": "Adresse e-mail invalide.",
	"alert.emailInUse": "Cette adresse e-mail est déjà utilisée.",
	"alert.exportSuccess": "Export des données réussi",
	"alert.exportFailed": "Échec de l'export des données",
	"alert.wrongPassword": "Mot de passe incorrect.",
	"alert.confirmDeleteAccount":
		"Êtes-vous sûr de vouloir supprimer votre compte ?",
	"alert.resetPasswordSent":
		"Un e-mail de réinitialisation a été envoyé à {{email}}.",
	"error.userNotLoggedIn": "Utilisateur non connecté",
	"error.passwordRequired": "Mot de passe requis",
	"error.reauthenticationFailed": "Échec de la ré-authentification :",
	"alert.updatingEmail": "Mise à jour de l'e-mail...",
	"alert.emailUpdatedSuccessfully": "L'adresse e-mail a bien été mise à jour",
	"alert.emailAlreadyVerified": "L'e-mail a déjà été vérifié",
	"alert.tooManyRequests":
		"Trop de demandes. Veuillez attendre avant de réessayer.",
	"alert.userDocumentNotFound": "Document utilisateur introuvable",
	"alert.reauthRequired": "Ré-authentification requise",
	"alert.operationNotAllowed":
		"Opération non autorisée. Vérifiez la configuration Firebase.",
	"alert.verificationInstructionsForUpdate":
		"Veuillez vérifier votre nouvel e-mail ({{email}}) en cliquant sur le lien reçu par e-mail pour finaliser le changement.",
	"settings.pendingEmailPrefix": "Nouvel e-mail en attente de vérification :",
	"settings.pendingEmailInstructions":
		"Vérifiez votre boîte e-mail et cliquez sur le lien de vérification pour finaliser le changement.",

	// Categories
	"category.food": "Alimentation",
	"category.general": "Général",
	"category.personal": "Personnel",
	"category.health": "Santé",
	"category.housing": "Logement",
	"category.savings": "Épargne",
	"category.income": "Revenu",

	// Subcategories
	"subCategory.food.groceries": "Courses",
	"subCategory.food.restaurant": "Restaurant",
	"subCategory.food.seazon": "Seazon",

	"subCategory.general.transport": "Transport",
	"subCategory.general.home": "Maison",
	"subCategory.general.utilities": "Services",
	"subCategory.general.donations": "Dons",
	"subCategory.general.other": "Autre",

	"subCategory.personal.vacation": "Vacances",
	"subCategory.personal.activities": "Sorties",
	"subCategory.personal.shopping": "Shopping",
	"subCategory.personal.sport": "Sport",
	"subCategory.personal.subscriptions": "Abonnements",
	"subCategory.personal.gifts": "Cadeaux",
	"subCategory.personal.other": "Autre",

	"subCategory.health.doctor": "Médecin",
	"subCategory.health.pharmacy": "Pharmacie",
	"subCategory.health.cosmectics": "Cosmétiques",
	"subCategory.health.other": "Autre",

	"subCategory.housing.loan": "Crédit immobilier/Loyer",
	"subCategory.housing.charges": "Charges",
	"subCategory.housing.insurance": "Assurances",

	"subCategory.income.salary": "Salaire",
	"subCategory.income.lunchTickets": "Tickets restaurant",
	"subCategory.income.socialSecurityRefund": "Remboursement sécurité sociale",
	"subCategory.income.healthInsuranceRefund": "Remboursement mutuelle",
	"subCategory.income.other": "Autre",

	// Terms and conditions page
	"terms.title": "Conditions Générales d'Utilisation",
	"terms.updated": "Dernière mise à jour : 24 juillet 2025",

	"terms.sections.editor": "1. Éditeur de l'application",
	"terms.sections.scope": "2. Objet de l'application",
	"terms.sections.acceptance": "3. Acceptation des CGU",
	"terms.sections.access": "4. Accès à l'application",
	"terms.sections.data": "5. Données personnelles",
	"terms.sections.intellectual": "6. Propriété intellectuelle",
	"terms.sections.liability": "7. Responsabilité",
	"terms.sections.deletion": "8. Suppression de compte",
	"terms.sections.changes": "9. Modification des CGU",
	"terms.sections.law": "10. Droit applicable",

	"terms.content.editor":
		"L'application <strong>Numerys</strong> est éditée par Paul BREARD, domicilié au 16 avenue George Pompidou, 92800 Puteaux, France. Pour toute question, vous pouvez nous contacter à l'adresse : {{emailLink}}.",
	"terms.content.scope":
		"Numerys est une application web gratuite permettant de gérer ses finances personnelles manuellement. Elle offre des analyses visuelles pour aider les utilisateurs à mieux comprendre leurs dépenses. L'application ne se connecte à aucun compte bancaire, mais autorise l'automatisation de certaines transactions récurrentes.",
	"terms.content.acceptance":
		"L'utilisation de l'application implique l'acceptation pleine et entière des présentes Conditions Générales d'Utilisation. En créant un compte sur Numerys, l'utilisateur reconnaît avoir pris connaissance des CGU et les accepter sans réserve.",
	"terms.content.access":
		"L'accès à l'application est gratuit et disponible à toute personne disposant d'un accès Internet. L'inscription et la création d'un compte utilisateur sont nécessaires pour bénéficier des fonctionnalités. Il n'existe pas de restriction géographique ou d'âge formelle, mais l'application est conçue principalement pour un public adulte et adolescent.",
	"terms.content.data":
		"L'utilisation de Numerys implique la collecte de données à caractère personnel (ex. : nom, email, transactions manuelles, préférences utilisateur). Ces données sont traitées conformément à la politique de confidentialité accessible via les pages de connexion, d'erreur et de réglages de l'application. L'utilisateur dispose à tout moment d'un droit d'accès, de rectification, d'exportation ou de suppression de ses données via les paramètres de son compte.",
	"terms.content.intellectual":
		"Tous les éléments constituant l'application Numerys, notamment le nom, le logo, l'identité visuelle, le design, les textes, les codes sources et les fonctionnalités, sont protégés au titre du droit d'auteur. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments de l'application, par quelque moyen que ce soit, est interdite sans l'autorisation écrite préalable de l'éditeur. L'utilisateur reste propriétaire de ses données personnelles et peut les exporter librement au format JSON depuis l'interface de l'application.",
	"terms.content.liability":
		"L'éditeur met en œuvre tous les moyens raisonnables pour assurer un accès de qualité à l'application, mais ne saurait être tenu responsable :",
	"terms.content.liability1":
		"En cas d'interruption du service pour maintenance ou mise à jour,",
	"terms.content.liability2":
		"En cas de dysfonctionnement technique indépendant de sa volonté,",
	"terms.content.liability3":
		"En cas d'erreur, d'inexactitude ou d'omission dans les analyses financières générées automatiquement.",
	"terms.content.liability.purpose":
		"Les informations fournies via Numerys ont une finalité exclusivement informative et ne sauraient constituer un conseil financier ou fiscal personnalisé.",
	"terms.content.deletion":
		"L'utilisateur peut supprimer son compte à tout moment depuis l'interface de gestion de son profil. La suppression entraîne la perte définitive de l'accès à ses données, sauf export préalable.",
	"terms.content.changes":
		"L'éditeur se réserve le droit de modifier à tout moment les présentes CGU. Toute modification substantielle fera l'objet d'une notification via l'application. L'utilisation continue de Numerys après la modification vaut acceptation des nouvelles conditions.",
	"terms.content.law":
		"Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.",

	// Privacy Policy page
	"privacy.title": "Politique de confidentialité",
	"privacy.updated": "Dernière mise à jour : 2 juillet 2025",

	"privacy.sections.who": "1. Qui sommes-nous ?",
	"privacy.content.who":
		"L'application Numerys est un outil personnel de gestion des finances, développé et maintenu par Paul BREARD, responsable du traitement des données. Pour toute question liée à la vie privée ou au Règlement Général sur la Protection des Données (RGPD), vous pouvez nous contacter à l'adresse suivante : {{emailLink}}.",

	"privacy.sections.data": "2. Données personnelles collectées",
	"privacy.content.data":
		"Nous collectons uniquement les données nécessaires à l'utilisation de l'application :",
	"privacy.content.data.auth":
		"Données d'authentification : adresse e-mail, mot de passe (crypté via Firebase Authentication).",
	"privacy.content.data.profile":
		"Données de profil : préférences utilisateur (langue, thème), rôle (user/admin).",
	"privacy.content.data.financial":
		"Données financières : transactions saisies par l'utilisateur (type, montant, catégorie, date, etc.).",
	"privacy.content.data.technical":
		"Données techniques : aucune donnée technique (adresse IP, logs, device ID, etc.) n'est enregistrée volontairement dans la base de données.",

	"privacy.sections.hosting": "3. Hébergement des données",
	"privacy.content.hosting1":
		"Les données utilisateur sont hébergées sur Google Firebase, dans la région europe-west1 (Belgique/UE). Les accès sont encadrés par les clauses contractuelles types approuvées par la Commission européenne.",
	"privacy.content.hosting2":
		"Le site web est quant à lui hébergé sur Vercel, une plateforme cloud basée aux États-Unis. Vercel peut enregistrer certaines informations techniques temporaires (adresse IP, données de requête, logs d'accès) dans le cadre de son fonctionnement normal, mais Numerys n'exploite pas directement ces données.",

	"privacy.sections.security": "4. Sécurité des données",
	"privacy.content.security":
		"Les accès sont protégés par l'authentification Firebase et des règles de sécurité strictes sur Firestore. Seul l'utilisateur a accès à ses propres données, sauf s'il reçoit un rôle administrateur. Aucune donnée personnelle ou sensible n'est accessible publiquement.",

	"privacy.sections.retention": "5. Durée de conservation des données",
	"privacy.content.retention":
		"Les données sont conservées tant que le compte est actif. En cas de suppression de compte, toutes les données personnelles (transactions, préférences, etc.) sont supprimées de manière immédiate et irréversible.",

	"privacy.sections.rights": "6. Droits des utilisateurs",
	"privacy.content.rights":
		"Conformément au RGPD, vous disposez des droits suivants :",
	"privacy.content.rights.access": "Droit d'accès à vos données.",
	"privacy.content.rights.update":
		"Droit de modification de vos informations (adresse e-mail, préférences).",
	"privacy.content.rights.delete":
		"Droit à la suppression de votre compte et de l'ensemble de vos données.",
	"privacy.content.rights.export": "Droit à l'export de vos données.",
	"privacy.content.rights.settings":
		"Ces droits peuvent être exercés directement depuis la page Réglages de votre compte, sans avoir besoin de nous contacter.",

	"privacy.sections.cookies": "7. Utilisation des cookies",
	"privacy.content.cookies":
		"L'application Numerys n'utilise pas de cookies propriétaires à des fins de suivi ou de publicité. Cependant, des cookies techniques tiers peuvent être déposés par les services suivants :",
	"privacy.content.cookies.auth":
		"Firebase Authentication : pour gérer les sessions utilisateur de manière sécurisée.",
	"privacy.content.cookies.host":
		"Vercel (hébergeur du site) : Vercel peut collecter des données techniques anonymes (ex. : adresse IP, informations de performance, journaux d'erreurs) à des fins d'analyse, de sécurité et de mise en cache. Ces données ne sont ni consultées ni exploitées par Numerys à des fins personnelles.",
	"privacy.content.cookies.consent":
		"Nous ne déposons aucun cookie non essentiel, c'est pourquoi aucune bannière de consentement n'est affichée actuellement. Si l'utilisation venait à évoluer (ex. : ajout de cookies analytiques ou publicitaires), une mise à jour de cette politique et un mécanisme de consentement seront mis en place.",

	"privacy.sections.updates": "8. Modifications",
	"privacy.content.updates":
		"Nous nous réservons le droit de mettre à jour cette politique de confidentialité. Tout changement sera affiché sur cette page avec la date de mise à jour.",
};

export default fr;
